module.exports = "/static/assets/3eb63579853c3f4c5323a51dcf4104ac.svg";